import React from 'react';

import { Grid, Paper, Typography, makeStyles } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import PaymentIcon from '@material-ui/icons/Payment';

import { formatMoeda, formatPorcentagem } from '../../../utils';
import CartaoIndicador from './CartaoIndicador';
import { CANCELADAS_COR, PALETA_MEIOS_PAGAMENTO } from './constantes';

const useStyles = makeStyles(() => ({
  bloco: {
    padding: 16,
    height: '100%',
  },
  titulo: {
    fontWeight: 600,
    marginBottom: 12,
  },
  subtitulo: {
    color: '#777',
    margin: '20px 0 8px',
  },
}));

function BlocoTipoNota({ titulo, cor, icone, dados }) {
  const classes = useStyles();
  const porMeioPagamento = dados.porMeioPagamento || [];

  return (
    <Paper variant="outlined" className={classes.bloco} style={{ borderTop: `4px solid ${cor}` }}>
      <Typography variant="subtitle1" className={classes.titulo} style={{ color: cor }}>
        {titulo}
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <CartaoIndicador
            rotulo="Documentos"
            destaque={dados.count || 0}
            cor={cor}
            icone={icone}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <CartaoIndicador
            rotulo="Valor Total"
            destaque={formatMoeda(dados.total || 0)}
            cor={cor}
            icone={icone}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <CartaoIndicador
            rotulo="% dos Documentos"
            destaque={formatPorcentagem(dados.percentual || 0)}
            cor={cor}
            icone={icone}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <CartaoIndicador
            rotulo="% do Valor Total"
            destaque={formatPorcentagem(dados.percentualValor || 0)}
            cor={cor}
            icone={icone}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <CartaoIndicador
            rotulo="Canceladas"
            destaque={dados.canceladas?.count || 0}
            subtitulo={formatMoeda(dados.canceladas?.total || 0)}
            cor={CANCELADAS_COR}
            icone={<CancelIcon />}
          />
        </Grid>
      </Grid>

      <Typography variant="body2" className={classes.subtitulo}>
        Meios de Pagamento
      </Typography>

      <Grid container spacing={2}>
        {porMeioPagamento.length === 0 && (
          <Grid item xs={12}>
            <Typography color="textSecondary" variant="body2">
              Nenhum pagamento encontrado no período.
            </Typography>
          </Grid>
        )}

        {porMeioPagamento.map((item, index) => (
          <Grid item xs={12} sm={6} key={item.id}>
            <CartaoIndicador
              rotulo={item.nome}
              destaque={formatMoeda(item.total || 0)}
              cor={
                PALETA_MEIOS_PAGAMENTO[index % PALETA_MEIOS_PAGAMENTO.length]
              }
              icone={<PaymentIcon />}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}

export default BlocoTipoNota;
